(function () {
  if (window.__pecQuoteCartFallbackInstalled) return;
  window.__pecQuoteCartFallbackInstalled = true;

  var originalFetch = window.fetch.bind(window);
  var nativeAddSeen = false;
  var fallbackAdding = false;

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('.pec-quote-header__cart span').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  async function getCart() {
    return originalFetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      return res.json();
    });
  }

  function scheduleFallback(plan) {
    if (!plan || !plan.ok || !plan.variantId || fallbackAdding) return;

    getCart().then(function (beforeCart) {
      var baselineCount = Number(beforeCart && beforeCart.item_count) || 0;

      window.setTimeout(async function () {
        try {
          if (nativeAddSeen || fallbackAdding) return;

          var currentCart = await getCart();
          var currentCount = Number(currentCart && currentCart.item_count) || 0;
          if (currentCount > baselineCount) {
            updateCartCount(currentCount);
            return;
          }

          fallbackAdding = true;
          var addResponse = await originalFetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: plan.variantId,
                quantity: Number(plan.quantity) || 1,
                properties: plan.properties || {},
              }],
            }),
          });

          if (addResponse.ok) {
            var afterCart = await getCart();
            updateCartCount(Number(afterCart && afterCart.item_count) || 0);
          }
        } catch (error) {
          console.error('[PEC Quote] Cart fallback failed', error);
        } finally {
          fallbackAdding = false;
        }
      }, 1800);
    }).catch(function () {});
  }

  window.fetch = async function (input, init) {
    var url = requestUrl(input);
    var isCartAdd = /\/cart\/add(?:\.js)?/.test(url);
    if (isCartAdd && !fallbackAdding) nativeAddSeen = true;

    var response = await originalFetch(input, init);

    if (/\/apps\/opc-express-proxy2\/variant\/plan/.test(url)) {
      response.clone().json().then(scheduleFallback).catch(function () {});
    }

    return response;
  };
})();
